import { useState } from 'react';
import { ScrollArea } from '@mantine/core';
import { LinksGroup } from '../NavbarLinksGroup/NavbarLinksGroup';
import { useSelector } from 'react-redux';
import { buildMenuByPermission } from './helpers';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import classes from './SideMenuNavbarLinks.module.css';
import { useMediaQuery } from '@mantine/hooks';

export function SideMenuNavbarLinks({
  toggleMobile,
  toggleDesktop
}: {
  toggleMobile: () => void;
  toggleDesktop: () => void;
}) {
  const { t } = useTranslation(['MenuOptions']);
  const location = useLocation();
  const isDesktop = useMediaQuery('(min-width: 768px)'); // Ajusta el ancho según tu tema o breakpoint "sm"
  const { company, user } = useSelector((state) => state.user);
  const permissions = user?.permission ?? null;
  const menuStructure = buildMenuByPermission(permissions, company, t);
  const links = menuStructure.map((item, index) => {
    let isActiveLink = item.link === location.pathname;
    let isAChildLinkByURL =
      location.pathname.startsWith(item.link) && item.link !== location.pathname;
    const isAChildLinkByChildLinkArray = item.childLinksURL
      ? item.childLinksURL.includes(location.pathname)
      : false;

    return (
      <LinksGroup
        {...item}
        key={item.label + index}
        toggleMenu={isDesktop ? toggleDesktop : toggleMobile}
        isActive={isActiveLink || isAChildLinkByURL || isAChildLinkByChildLinkArray}
      />
    );
  });
  return (
    <ScrollArea className={classes.links}>
      <div className={classes.linksInner}>{links}</div>
    </ScrollArea>
  );
}
